export default {
    title: 'Calendário',
    subtitle: 'ADICIONE DATAS IMPORTANTES À SUA AGENDA',
    headerSubtitle: 'Entenda a dinâmica dos eventos astrológicos e programe-se para aproveitar cada momento.',
    skyMoment: 'Você também pode <a href={calendarUrl}>adicionar eventos astrológicos</a> com as nossas dicas ao seu calendário pessoal!',
    warning: '<b>Atenção:</b> Algumas versões do aplicativo Google Agenda podem apresentar erro na sincronização pelo smartphone. Em caso de problemas, tente sincronizar pelo desktop ou então <a href={contactUrl} target="_blank">entre em contato com nosso suporte</a> para que nossa equipe possa te ajudar.',
    
    card: {
        basic: {
            title: 'CALENDÁRIO BÁSICO',
            subtitle: 'Entrada de planetas nos signos, mudança de fases da lua, retrogradações e eclipses',
        }
    },

    button: {
        google: {
            icon: 'Ícone do Google Calendar',
            authorize: 'Autorizar acesso',
            binded: 'Calendário vinculado',
            authorized: 'Vincular calendário'
        }
    },

    disclaimer: {
        google: {
            default: 'Para usar nosso calendário dentro da Agenda Google você precisa de um endereço de e-mail @gmail.com. Não é necessário que seja o mesmo e-mail cadastrado no Astrolink.',
            binded: 'Toque no link abaixo ou copie-o e cole dentro da sua Google Agenda:'
        },
        apple: {
            default: 'Para usar nosso calendário dentro do Calendário Apple você precisa de um endereço de e-mail associado ao iCloud. Não é necessário que seja o mesmo e-mail cadastrado no Astrolink.',
            binded: 'Dentro do seu Calendário Apple, acesse a sessão Arquivo > Nova assinatura de Calendário e cole o link abaixo:'
        },
    },

    error: {
        getUser: 'Erro ao buscar dados do usuário',
        getCalendar: 'Erro ao buscar informações do calendário',
        insertCalendar: 'Erro ao inserir agenda no calendário',
    },

    versionMismatch: {
        title: 'Você não tem a versão mais recente do nosso aplicativo!',
        text: 'Para usar o calendário, acesse a <a href="{storeUrl}" target="_blank">{storeName}</a> e faça o download da versão mais recente do aplicativo Astrolink.'
    }
};